import React, { useState, createContext, useContext } from 'react';
type LeadFormContextType = {
  isOpen: boolean;
  openForm: () => void;
  closeForm: () => void;
};
const LeadFormContext = createContext<LeadFormContextType>({
  isOpen: false,
  openForm: () => {},
  closeForm: () => {}
});
export function useLeadForm() {
  return useContext(LeadFormContext);
}
export function LeadFormProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const openForm = () => setIsOpen(true);
  const closeForm = () => setIsOpen(false);
  return <LeadFormContext.Provider value={{
    isOpen,
    openForm,
    closeForm
  }} data-id="element-14">
      {children}
    </LeadFormContext.Provider>;
}